var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.$can(_vm.ActionEnum.READ, _vm.ResourceEnum.PARTNER) ? _c('div', [_c('v-list-item', [_c('v-select', {
    attrs: {
      "items": _vm.partners,
      "item-text": "companyName",
      "persistent-hint": "",
      "return-object": "",
      "outlined": ""
    },
    model: {
      value: _vm.partner,
      callback: function callback($$v) {
        _vm.partner = $$v;
      },
      expression: "partner"
    }
  })], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }